import { useAtom } from "jotai";
import { useHydrateAtoms } from "jotai/utils";
import type { QuoteComparisonPageFeatureProps } from "../../pages";
import { quoteComparisonPageAtom } from "../../store";

export const useSetQcpState = (
  components: QuoteComparisonPageFeatureProps[],
) => {
  useHydrateAtoms([[quoteComparisonPageAtom, components]]);
};

// This is a simple wrapper around Jotai
// to reduce imports in components.
export const useQuoteComparisonPageState = () =>
  useAtom(quoteComparisonPageAtom);
